import { Observable, throwError } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, catchError, timeout } from 'rxjs/operators';
import { Global } from '../../global.constants';
import { Utility } from '../../utility';
import { DBkeys } from '../auth/db-keys';
import { ReadConfigService } from '../common/read-config.service';

@Injectable({
  providedIn: 'root'
})
export class UploadService {

  constructor(private httpClient: HttpClient, protected readConfigService: ReadConfigService) { }
  apiUrl = this.readConfigService.getApiUrl();
  apiTimeout = this.readConfigService.getApiTimeout();
  reqHeader = new HttpHeaders({
    'Content-Type': 'application/json'
  });

  UserInfo(): any {
    const userInfo = {
      encryptOrg: Utility.removeQuotes(sessionStorage.getItem(DBkeys.ENC_ORGID)),
      encryptUsr: Utility.removeQuotes(sessionStorage.getItem(DBkeys.ENC_USER))
    };
    return userInfo;
  }

  getUploadUrl() {
    return this.apiUrl + Global.BASE_PM_UPLOAD_FROMFILE_ENDPOINT;
  }

  getHistory(fileType?: string): Observable<any> {
    const url = this.apiUrl + Global.BASE_PM_UPLOAD_ENDPOINT;
    const obj = { fileType, userInfo: this.UserInfo() };
    return this.httpClient.post<any>(url, obj, { headers: this.reqHeader })
      .pipe(this.handleError());
  }

  getLocations(): Observable<any> {
    const url = this.apiUrl + Global.BASE_PM_UPLOAD_LOC_ENDPOINT;
    const obj = { userInfo: this.UserInfo() };
    return this.httpClient.post<any>(url, obj, { headers: this.reqHeader })
      .pipe(this.handleError());
  }

  getFileCategories(): Observable<any> {
    const url = this.apiUrl + Global.BASE_PM_UPLOAD_FILECAT_ENDPOINT;
    const obj = { userInfo: this.UserInfo() };
    return this.httpClient.post<any>(url, obj, { headers: this.reqHeader })
      .pipe(this.handleError());
  }

  handleError() {
    return timeout(this.apiTimeout),
      catchError((err: any) => {
        return throwError(err || 'Server error');
      }),
      map((v: any) => {
        if (v) {
          return v;
        }
      });
  }
}
